import { render, staticRenderFns } from "./DesignPriorityList.vue?vue&type=template&id=5bac04df&"
import script from "./DesignPriorityList.vue?vue&type=script&lang=js&"
export * from "./DesignPriorityList.vue?vue&type=script&lang=js&"
import style0 from "./DesignPriorityList.vue?vue&type=style&index=0&id=5bac04df&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports